module.exports = __webpack_public_path__ + "static/media/f1_converted.dc6227e5.mp4";